import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'
import { CheckboxGroup, Checkbox } from '@cb/apricot-react'
import { CBInputMethod } from '@cb/apricot'

function CheckboxGroupField({
  groupName,
  initialValues,
  required,
  title,
  options,
  disabled,
  fieldsetId,
  vertical,
  specialHandlers = {},
}) {
  const { register, setValue, watch } = useFormContext()
  const selected = watch(groupName)

  useEffect(() => {
    CBInputMethod()
  }, [])

  return (
    <>
      <input {...register(groupName)} type="hidden" defaultValue={initialValues} />
      <CheckboxGroup legend={title} fieldsetId={fieldsetId} required={required} vertical={vertical}>
        {options.map(opt => {
          const name = `${groupName}.${opt.value}`
          const SpecialHandler = specialHandlers?.[opt.value] ?? null
          return (
            <Fragment key={name}>
              <Checkbox
                name={name}
                value={opt.value}
                label={opt.label}
                checked={selected.includes(opt.value)}
                disabled={disabled}
                onChange={checked => {
                  if (!checked) {
                    setValue(
                      groupName,
                      selected.filter(s => s !== opt.value),
                      { shouldValidate: true, shouldDirty: true }
                    )
                  } else if (opt.singleSelect) {
                    setValue(groupName, [opt.value], { shouldValidate: true, shouldDirty: true })
                  } else {
                    // Set list to the selected option and the remaining options that are NOT singleSelect
                    setValue(
                      groupName,
                      [
                        opt.value,
                        ...selected.filter(
                          selectedOpt =>
                            !options.find(
                              option => option.value === selectedOpt && option.singleSelect
                            )
                        ),
                      ],
                      { shouldValidate: true, shouldDirty: true }
                    )
                  }
                }}
              />
              {specialHandlers?.[opt.value] && selected.includes(opt.value) ? (
                <div style={{ marginLeft: '32px' }}>
                  <SpecialHandler disabled={disabled} />
                </div>
              ) : null}
            </Fragment>
          )
        })}
      </CheckboxGroup>
    </>
  )
}

export default CheckboxGroupField
